import { createFileRoute, Navigate } from '@tanstack/react-router';

import { SkipAllowListsSection } from '@apps/web/components/settings/skip_allow_lists_section';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute(
    '/_app/settings/shift-confirmation-skip-allow-lists',
)({
    component: ShiftConfirmationSkipAllowListsPage,
});

function ShiftConfirmationSkipAllowListsPage() {
    const { organizationId, gates } = useSettingsGates();
    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }

    return (
        <SettingsPageShell
            title="Shift confirmation skip / allow lists"
            description="Control which caregivers, clients, and coordinators are included in clock reminders and shift confirmation outreach."
        >
            <SkipAllowListsSection
                organizationId={organizationId}
                visibleSections={['clock_reminders', 'shift_confirmations']}
                title="Shift Confirmation Skip/Allow Lists"
                description="Control which caregivers, clients, and coordinators are included in clock reminders and shift confirmation outreach."
            />
        </SettingsPageShell>
    );
}
